// Breakfast Cereals card game data - ranked by popularity/sales
export const CEREALS_CARDS = [
  { id: 1, name: "Cheerios", rank: 1, image: "/images/cereals/cereals_1.jpg" },
  { id: 2, name: "Frosted\nFlakes", rank: 2, image: "/images/cereals/cereals_2.jpg" },
  { id: 3, name: "Honey Nut\nCheerios", rank: 3, image: "/images/cereals/cereals_3.jpg" },
  { id: 4, name: "Froot\nLoops", rank: 4, image: "/images/cereals/cereals_4.jpg" },
  { id: 5, name: "Lucky\nCharms", rank: 5, image: "/images/cereals/cereals_5.jpg" },
  { id: 6, name: "Cinnamon\nToast Crunch", rank: 6, image: "/images/cereals/cereals_6.jpg" },
  { id: 7, name: "Frosted\nMini-Wheats", rank: 7, image: "/images/cereals/cereals_7.jpg" },
  { id: 8, name: "Cap'n\nCrunch", rank: 8, image: "/images/cereals/cereals_8.jpg" },
  { id: 9, name: "Raisin\nBran", rank: 9, image: "/images/cereals/cereals_9.jpg" },
  { id: 10, name: "Cocoa\nPuffs", rank: 10, image: "/images/cereals/cereals_10.jpg" },
  { id: 11, name: "Rice\nKrispies", rank: 11, image: "/images/cereals/cereals_11.jpg" },
  { id: 12, name: "Apple\nJacks", rank: 12, image: "/images/cereals/cereals_12.jpg" },
  { id: 13, name: "Corn\nFlakes", rank: 13, image: "/images/cereals/cereals_13.jpg" },
  { id: 14, name: "Life", rank: 14, image: "/images/cereals/cereals_14.jpg" },
  { id: 15, name: "Honey\nBunches\nof Oats", rank: 15, image: "/images/cereals/cereals_15.jpg" },
  { id: 16, name: "Trix", rank: 16, image: "/images/cereals/cereals_16.jpg" },
  { id: 17, name: "Golden\nGrahams", rank: 17, image: "/images/cereals/cereals_17.jpg" },
  { id: 18, name: "Cookie\nCrisp", rank: 18, image: "/images/cereals/cereals_18.jpg" },
  { id: 19, name: "Grape-Nuts", rank: 19, image: "/images/cereals/cereals_19.jpg" },
  { id: 20, name: "Reese's\nPuffs", rank: 20, image: "/images/cereals/cereals_20.jpg" },
  { id: 21, name: "Special K", rank: 21, image: "/images/cereals/cereals_21.jpg" },
  { id: 22, name: "Wheaties", rank: 22, image: "/images/cereals/cereals_22.jpg" },
  { id: 23, name: "Corn\nPops", rank: 23, image: "/images/cereals/cereals_23.jpg" },
  { id: 24, name: "Kix", rank: 24, image: "/images/cereals/cereals_24.jpg" },
  { id: 25, name: "Count\nChocula", rank: 25, image: "/images/cereals/cereals_25.jpg" }
];
